// extracted by mini-css-extract-plugin
export default {"pageContainer":"Bind_pageContainer__v-XTE","content":"Bind_content__QS-kE"};